import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from '../../../components/Icon/Icon';
import ButtonT3 from '../../../components/lib/ButtonT3/ButtonT3';
import { ButtonT3Size, ButtonT3Theme } from '../../../components/lib/ButtonT3/constants';
import QATags from '../../../constants/QATags';
import { createBEM } from '../../../lib/utils/css';

import { InfoCardIcons, InfoCardTheme } from './constants';

import './InfoCard.scss';

export default class InfoCard extends React.Component {
  static propTypes = {
    primaryText: PropTypes.node,
    secondaryText: PropTypes.node,
    theme: PropTypes.oneOf(values(InfoCardTheme)),
    ctaButton: PropTypes.node,
    infoContentCTA: PropTypes.node,
    infoContent: PropTypes.node,
    infoContentFooter: PropTypes.node,
    isMobile: PropTypes.bool,
    withFooterBar: PropTypes.bool,
    isOldAndroid: PropTypes.bool,
    eventAction: PropTypes.string,
    logEvent: PropTypes.func,
    qaTag: PropTypes.string,
    isSingleCard: PropTypes.bool,
    isLanding: PropTypes.bool,
  };

  state = {
    isClosed: this.props.isMobile,
  };

  componentWillMount() {
    this.itemRef = React.createRef();
  }

  toggleActiveState = event => {
    event.preventDefault();
    if (this.state.isClosed && this.props.eventAction) {
      this.props.logEvent('expand_' + this.props.eventAction);
    }
    this.setState({
      isClosed: !this.state.isClosed,
    });
    setTimeout(() => {
      if (!this.state.isClosed) {
        if (this.props.isOldAndroid) {
          this.itemRef.current.scrollIntoView({ block: 'start' });
        } else {
          window.scroll({
            top: this.itemRef.current.offsetTop,
            behavior: 'smooth',
          });
        }
      }
    }, 250);
  };

  renderHeader = () => {
    return (
      <div className='InfoCard__header'>
        <h1 className='InfoCard__header__primaryText'>{this.props.primaryText}</h1>
        <h2 className='InfoCard__header__secondaryText'>{this.props.secondaryText}</h2>
      </div>
    );
  };

  renderCTAButton = () => {
    return <div className='InfoCard__cta'>{this.props.ctaButton}</div>;
  };

  renderInfoContent = () => {
    return (
      <div className='InfoCard__content'>
        <div className='InfoCard__content__cta'>{this.props.infoContentCTA}</div>
        <div className='InfoCard__content__belowFold'>
          {this.props.infoContent}
          {this.props.infoContentFooter && this.renderInfoContentFooter()}
        </div>
      </div>
    );
  };

  renderInfoContentFooter = () => {
    const infoContentFooterClasses = createBEM('InfoCard__content__footer', {
      withBar: this.props.withFooterBar,
    });
    return (
      <div className={infoContentFooterClasses}>
        <div className='InfoCard__content__footer__bar' />
        {this.props.infoContentFooter}
      </div>
    );
  };

  renderChevron = () => {
    return (
      <div className='InfoCard__chevron'>
        <ButtonT3
          onClick={this.toggleActiveState}
          theme={ButtonT3Theme.WHITE}
          size={ButtonT3Size.LARGE}
          qaTag={QATags.ICC}
        >
          <Icon glyph={InfoCardIcons.CHEVRON_DOWN} />
        </ButtonT3>
      </div>
    );
  };

  render() {
    const { theme, qaTag } = this.props;
    const infoCardClassNames = createBEM('InfoCard', {
      [theme]: !!theme,
      mobile: this.props.isMobile,
      closed: this.props.isMobile && this.state.isClosed && !this.props.isSingleCard,
      single: this.props.isSingleCard,
      landing: this.props.isLanding,
    });
    return (
      <article className={infoCardClassNames} ref={this.itemRef} data-qa={qaTag}>
        {this.renderHeader()}
        {this.props.ctaButton && this.renderCTAButton()}
        {this.renderInfoContent()}
        {this.props.isMobile ? this.renderChevron() : null}
      </article>
    );
  }
}
